import { i18nDocumentType } from 'i18n/TT/i18nDocumentType';
import { TravellerDocument } from 'services/SwaggerApi';

export const formatDocument = (document: TravellerDocument) => {
    const fullNumber = [document.series, document.number].join(' ').trim();
    const documentType = i18nDocumentType(document.document_type);

    return `${documentType}, ${fullNumber}`;
};
